export var ACTION;
(function (ACTION) {
    ACTION["ENTER_EMAIL"] = "ENTER_EMAIL";
    ACTION["CONTINUE"] = "CONTINUE";
    ACTION["DISABLE_CONTINUE"] = "DISABLE_CONTINUE";
    ACTION["ENABLE_CONTINUE"] = "ENABLE_CONTINUE";
    ACTION["BACK"] = "BACK";
    ACTION["VERIFY_OTP"] = "VERIFY_OTP";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["CLOSE_MODAL_ACTION"] = "CLOSE_MODAL_ACTION";
})(ACTION || (ACTION = {}));
